<footer class="er-footer">
  <div class="er-footer-line">
    <span>Copyright © {{ currentyear }} <a class="er-brand">Easy<span class="er-rin">Rin</span></a>. All rights reserved.</span>
    <span class="er-footer-dot" aria-hidden="true">·</span>
    <a href="https://yourmudra.com/page/financial-services" target="_blank" class="er-terms">Terms &amp; Conditions</a>
  </div>
  <small class="er-os-note">Operating system must be Windows 10 or above</small>
</footer>
